export const validationEn: any = {
  infantsNumberMessage:
    "Number of infants mustn't be greater than number of adults",
  requiredInputMessage: "Required field",
  requiredDateMessage: "Enter a valid date",
  requiredSelectionMessage: "Select an option",
};
